import { Button, Form } from "react-bootstrap";
import { ChangeEvent, useState, useEffect } from "react";
import { sendEmailUserRestorePwd } from "../api/authAPI";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { SendEmailDto } from "../../admin/generic/types";


interface FormData {
  email: string;
}

type RestorePwdFormProps = {
    language: string;
};

export const EmailPwdRestoreForm = ({ language }: RestorePwdFormProps) => {

    const [formData, setFormData] = useState<FormData>({
        email: '',
  });

    const [error, setError] = useState<string>('');
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        i18n.changeLanguage(language);
    }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    };

  const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
  
      

      const body: SendEmailDto = {
          email: formData.email,
          typeEmail: "restore",
      }

      try {
          if (!formData.email) {
              setError(t("auth:errorsRestorePwd.messageRestorePwdValidateEmail"));
              return;
          }
          setError("");
          await sendEmailUserRestorePwd(body);
          navigate(`/`)
      } catch (e) {
          setError(t("auth:errorsRestorePwd.messageRestorePwdGeneric"));
          return;
      }

  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-4">
              <Form.Label>{t("auth:restorePwd.textEmailRestorePwd")}</Form.Label>
        <Form.Control
          type="text"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
      </Form.Group>

      {error && <div className="alert alert-danger mb-3">{error}</div>}
          <p>{t("auth:restorePwd.text2EmailRestorePwd")}</p>
          <p>{t("auth:restorePwd.text3EmailRestorePwd")}</p>
          <p>{t("auth:restorePwd.text4EmailRestorePwd")}</p>
          <div className="d-flex justify-content-end">
        <Button variant="success" type="submit">
                  {t("common:buttons.buttonRestorePwd")}
        </Button>
      </div>
    </Form>
  );
}